<div class="bg-white px-4">
    <header class="mb-10 flex items-center px-8 pt-10">
        <div class="flex items-center">
            <mat-icon
                class="mr-5 scale-150"
                fontSet="material-symbols-outlined">
                graph_1
            </mat-icon>
            <h1 class="text-3xl font-medium">A/B Tests</h1>
        </div>
    </header>
    @if (abTestsStore.isFulfilled()) {
        <button
            mat-flat-button
            color="primary"
            routerLink="0">
            Add A/B test
        </button>
        <table
            mat-table
            [dataSource]="dataSource">
            <ng-container matColumnDef="name">
                <th
                    mat-header-cell
                    *matHeaderCellDef>
                    Name
                </th>
                <td
                    mat-cell
                    *matCellDef="let element">
                    {{ element.name }}
                </td>
            </ng-container>
            <ng-container matColumnDef="startDate">
                <th
                    mat-header-cell
                    *matHeaderCellDef>
                    Start date
                </th>
                <td
                    mat-cell
                    *matCellDef="let element">
                    {{ element.startDate | date: "dd.MM.yyyy HH:mm:ss" : "UTC" }}
                </td>
            </ng-container>
            <ng-container matColumnDef="endDate">
                <th
                    mat-header-cell
                    *matHeaderCellDef>
                    End date
                </th>
                <td
                    mat-cell
                    *matCellDef="let element">
                    {{ element.endDate | date: "dd.MM.yyyy HH:mm:ss" : "UTC" }}
                </td>
            </ng-container>
            <ng-container matColumnDef="active">
                <th
                    mat-header-cell
                    *matHeaderCellDef>
                    Active
                </th>
                <td
                    mat-cell
                    *matCellDef="let element">
                    <div class="flex items-center">
                        <mat-checkbox
                            disabled
                            [checked]="element.isActive"></mat-checkbox>
                    </div>
                </td>
            </ng-container>
            <ng-container matColumnDef="actions">
                <th
                    mat-header-cell
                    *matHeaderCellDef></th>
                <td
                    class="self-end"
                    mat-cell
                    *matCellDef="let element">
                    <button
                        mat-button
                        [routerLink]="element.id">
                        Manage
                    </button>
                </td>
            </ng-container>
            <tr
                mat-header-row
                *matHeaderRowDef="displayedColumns()"></tr>
            <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns()"></tr>
        </table>
    }
</div>
